import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr auto 16px;
	align-items: center;
	justify-content: center;
	gap: 10px;
	width: 100%;
	height: 50px;
	padding: 0 20px;
	border-radius: 10px;
	background-color: #ffbb00;

	${Text} {
		font-size: 16px;
		color: #000000;

		&:first-child {
			font-weight: 400;
			opacity: 0.5;
		}
	}
`;

export { StyledContainer };
